"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _tinycolor = _interopRequireDefault(require("tinycolor2"));
var _utils = require("../utils");
if (require('exenv').canUseDOM) require('./progress.scss');
const colorStrategy = color => (0, _tinycolor.default)(color).isDark() ? '#FFFFFF' : '#333333';
const Progress = _ref => {
  let className = _ref.className,
    value = _ref.value,
    max = _ref.max,
    valueTopLeft = _ref.valueTopLeft,
    valueTopCenter = _ref.valueTopCenter,
    valueTopRight = _ref.valueTopRight,
    valueBottomLeft = _ref.valueBottomLeft,
    valueBottomCenter = _ref.valueBottomCenter,
    valueBottomRight = _ref.valueBottomRight,
    fillColor = _ref.fillColor;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('progress-container', className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "progress-top"
  }, valueTopLeft && /*#__PURE__*/_react.default.createElement("div", {
    className: "progress-top-left"
  }, valueTopLeft), valueTopCenter && /*#__PURE__*/_react.default.createElement("div", {
    className: "progress-top-center"
  }, valueTopCenter), valueTopRight && /*#__PURE__*/_react.default.createElement("div", {
    className: "progress-top-right"
  }, valueTopRight)), /*#__PURE__*/_react.default.createElement("div", {
    className: "progress",
    value: value,
    max: max
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "progress-value",
    style: {
      backgroundColor: fillColor,
      width: "".concat(value > 100 ? 100 : value, "%")
    }
  }, value > 5 && /*#__PURE__*/_react.default.createElement("span", {
    className: "percentage",
    style: {
      color: colorStrategy(fillColor)
    }
  }, _utils.numberUtils.number(value).split(',')[0], "%"))), /*#__PURE__*/_react.default.createElement("div", {
    className: "progress-bottom"
  }, valueBottomLeft && /*#__PURE__*/_react.default.createElement("div", {
    className: "progress-bottom-left"
  }, valueBottomLeft), valueBottomCenter && /*#__PURE__*/_react.default.createElement("div", {
    className: "progress-bottom-center"
  }, valueBottomCenter), valueBottomRight && /*#__PURE__*/_react.default.createElement("div", {
    className: "progress-bottom-right"
  }, valueBottomRight)));
};
Progress.defaultProps = {
  max: 100,
  value: 0,
  fillColor: 'hsl(171, 100%, 41%)'
};
var _default = exports.default = Progress;